<template>
  <div id="base-autocomplete-product">
    <v-autocomplete
      :items="products"
      :loading="isLoading"
      :search-input.sync="search"
      :value="productNameByValue"
      @input="findId"
      class="font-weight-medium"
      hide-no-data
      hide-selected
      item-text="productname"
      item-value="productname"
      label="ค้นหาความรู้ด้วยผลผลิต"
      single-line
      v-bind="$attrs"
    ></v-autocomplete>
  </div>
</template>

<script>
import _ from 'lodash/orderBy'
export default {
  name: '',
  props: {
    value: {
      type: [String, Object]
    }
  },
  data() {
    return {
      productNameByValue: '',
      isLoading: false,
      search: null,
      state: []
    }
  },
  watch: {
    value() {
      this.value.productId
        ? this.findName(this.value.productId) // editing
        : (this.productNameByValue = '') // craeting
    },
    search() {
      // Items have already been loaded
      if (this.products.length > 0) return

      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true

      // Lazily load input items
      setTimeout(() => {
        this.state = _(this.$store.state.Product.searchProducts, ['id', 'orders'], ['asc', 'asc'])
        this.isLoading = false
      }, 1000)
    }
  },
  computed: {
    products() {
      return this.state
    }
  },
  methods: {
    findName(value) {
      this.productNameByValue = this.products.find(item => item.productid == value).productname
    },
    findId(productName) {
      let productId = this.products
        .filter(item => item.productname == productName)
        .map(item => item.productid)
        .toString()
      this.$emit('input', { productId: productId, productName: productName })
    }
  }
}
</script>

<style lang="scss" scoped></style>
